import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
  Grid,
} from "@mui/material";

function TrainingRegistration() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    track: "",
    note: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      await addDoc(collection(db, "training_registrations"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        track: formData.track,
        note: formData.note,
        createdAt: serverTimestamp(),
      });

      setStatus("✅ Registration successful! Our team will contact you soon.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        track: "",
        note: "",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      setStatus("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <Container sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Training Program Registration
      </Typography>

      <Typography
        variant="body1"
        sx={{ maxWidth: 600, mx: "auto", mb: 4, color: "gray" }}
      >
        Register for Full‑Stack Development, AI/ML Foundations, SDET Automation,
        or UI/UX & Product Design. Our team will reach out with details.
      </Typography>

      <Box
  component="form"
  onSubmit={handleSubmit}
  sx={{
    mt: 4,
    p: 4,
    borderRadius: 3,
    maxWidth: 700,
    mx: "auto",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
  }}
>
  <Grid container spacing={3}>

    {/* Full Name */}
    <Grid item xs={12} sm={6} sx={{ minHeight: 100 }}>
      <TextField
        label="Full Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        fullWidth
        required
        sx={{
          "& .MuiInputBase-root": { height: 56 },
          "& .MuiFormHelperText-root": { display: "none" }
        }}
      />
    </Grid>

    {/* Email */}
    <Grid item xs={12} sm={6} sx={{ minHeight: 100 }}>
      <TextField
        label="Email Address"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        fullWidth
        required
        sx={{
          "& .MuiInputBase-root": { height: 56 },
          "& .MuiFormHelperText-root": { display: "none" }
        }}
      />
    </Grid>

    {/* Phone */}
    <Grid item xs={12} sm={6} sx={{ minHeight: 100 }}>
      <TextField
        label="Phone Number"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        fullWidth
        required
        sx={{
          "& .MuiInputBase-root": { height: 56 },
          "& .MuiFormHelperText-root": { display: "none" }
        }}
      />
    </Grid>

    {/* Track Selection */}
    <Grid item xs={12} sm={6} sx={{ minWidth: 150 }}>
      <TextField
        select
        label="Select Training Track"
        name="track"
        value={formData.track}
        onChange={handleChange}
        fullWidth
        required
        sx={{
          "& .MuiInputBase-root": { height: 56 },
          "& .MuiFormHelperText-root": { display: "none" },
          "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      width: "100%"   // prevents shrinking
    }
        }}
      >
        <MenuItem value="Full‑Stack Development">Full‑Stack Development</MenuItem>
        <MenuItem value="AI/ML Foundations">AI/ML Foundations</MenuItem>
        <MenuItem value="SDET Automation">SDET Automation</MenuItem>
        <MenuItem value="Backend Development">Backend Development</MenuItem>
      </TextField>
    </Grid>

    {/* Notes */}
    <Grid item xs={12}>
      <TextField
        label="Tell us about your background (optional)"
        name="note"
        value={formData.note}
        onChange={handleChange}
        fullWidth
        multiline
        rows={4}
      />
    </Grid>

    {/* Submit Button */}
    <Grid item xs={12}>
      <Button
        type="submit"
        variant="contained"
        color="success"
        fullWidth
        sx={{ py: 1.4 }}
      >
        Submit Registration
      </Button>
    </Grid>
  </Grid>
</Box>

      {status && (
        <Typography
          variant="body1"
          sx={{ mt: 3, color: status.startsWith("❌") ? "red" : "green" }}
        >
          {status}
        </Typography>
      )}
    </Container>
  );
}

export default TrainingRegistration;